// React/finance-app/src/features/tt-insights/tabs/KpiTab.jsx
import React from 'react';
import ExportButton from '../ExportButton';

const KpiTab = ({ loading, kpiRows, userCode }) => (
  <div className="card mb-4">
    <div className="card-header">KPI State for: {userCode}</div>
    <div className="card-body table-responsive">
      {!loading && (
        <div className="mb-2 d-flex justify-content-end">
          <ExportButton
            disabled={kpiRows.length === 0}
            filenameBase={`kpi_${userCode || 'unknown'}`}
            sheetName="KPI State"
            columns={[
              { key: "name", header: "KPI" },
              { key: "curValue", header: "Current Value" },
              { key: "curRank", header: "Current Rank" },
              { key: "curDate", header: "Current Date" },
              { key: "prevValue", header: "Previous Value" },
              { key: "prevRank", header: "Previous Rank" },
              { key: "prevDate", header: "Previous Date" },
            ]}
            rows={kpiRows}
          />
        </div>
      )}
      {loading ? (
        <div className="text-muted">Loading…</div>
      ) : (
        <table className="table table-sm table-bordered table-striped">
          <thead>
            <tr>
              <th rowSpan="2" style={{ verticalAlign: 'middle' }}>KPI</th>
              <th colSpan="3" className="text-center">Current</th>
              <th colSpan="3" className="text-center">Previous</th>
            </tr>
            <tr>
              <th>Value</th>
              <th>Rank</th>
              <th>Date</th>
              <th>Value</th>
              <th>Rank</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {kpiRows.map((row, idx) => (
              <tr key={idx}>
                <td>{row.name}</td>
                <td>{row.curValue}</td>
                <td>{row.curRank}</td>
                <td>{row.curDate}</td>
                <td>{row.prevValue ?? '—'}</td>
                <td>{row.prevRank ?? '—'}</td>
                <td>{row.prevDate ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
);

export default KpiTab;
